import { render, staticRenderFns } from "./ProductRatingSection.vue?vue&type=template&id=2f771bd2&"
import script from "./ProductRatingSection.vue?vue&type=script&lang=js&"
export * from "./ProductRatingSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports